/**
 * Top Categories Component
 * Displays top CE categories with hours and activity counts
 */

import { Box, Paper, Card, Typography } from '@mui/material'
import { BarChart } from '@mui/icons-material'
import { TopCategory } from '../../types'

interface TopCategoriesProps {
  data: TopCategory[]
}

export default function TopCategories({ data }: TopCategoriesProps) {
  // Limit to top 6 categories for layout purposes
  let topCategories = data.slice(0, 6)

  return (
    <Paper sx={{ p: 3 }}>
      <Typography
        variant="h6"
        sx={{ mb: 3, display: 'flex', alignItems: 'center', gap: 1 }}
      >
        <BarChart />
        Top CE Categories
      </Typography>

      <Box className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {topCategories.map((category) => (
          <Box key={category.categoryName}>
            <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1,
                  fontWeight: 600,
                  minHeight: '2.5em',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                }}
              >
                {category.categoryName}
              </Typography>
              <Typography variant="h6" color="primary.main" sx={{ mb: 0.5 }}>
                {category.totalHours}h
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {category.activityCount}{' '}
                {category.activityCount === 1 ? 'activity' : 'activities'}
              </Typography>
            </Card>
          </Box>
        ))}
      </Box>

      {data.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body2" color="text.secondary">
            No category data available for the selected period
          </Typography>
        </Box>
      )}
    </Paper>
  )
}
